module.exports = __webpack_public_path__ + "/images/cover-multi-bolso-iphone.3e030d1.png";